import React from 'react';
import Header from '../components/Header';
import BuyerStatusCard from '../components/Rewards/BuyerStatusCard';
import BusinessPerformance from '../components/Rewards/BusinessPerformance';
import NextMilestoneCard from '../components/Rewards/NextMilestoneCard';
import RewardsGrid from '../components/Rewards/RewardsGrid';
import './RewardsPage.css';

const RewardsPage = () => {
  return (
    <div className="rewards-page">
      <Header title="Rewards" />
      <main className="rewards-content">
        <BuyerStatusCard />
        <BusinessPerformance />
        <NextMilestoneCard />
        <RewardsGrid />
      </main>
    </div>
  );
};

export default RewardsPage;